
module.cC({
    name: 'ProgramBaseController',
    inject: ['$scope', '$state', 'program', 'permissions', 'ModelService'],
    data: {
        program: 'program',
        permissions: 'permissions',
    },

    listen: {
        program: {
            issues: '_refreshProgram',
        }
    },

    methods: {
        _refreshProgram: function(programId) {
            var program = this.program;
            if (programId === this.program.id) {
                this.ModelService.debouncedRelation('program', program.id, 'summary')
                    .then(function(summary) {
                        angular.copy(summary, program)
                    });
            }
        }
    },
});
